import React, { useCallback, useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import AppCard from 'app/components/AppCard'
import { RootState } from 'app/state/types'
import { setAppsGrid, setIsLoading } from 'app/state/appSlice'
import { getAppsGrid } from 'app/services/client'
import { generatePath } from 'react-router-dom'
import { APP_ROUTES } from 'app/components/AppRouter/routes'
import { makeDownloadApkLink } from 'app/utils/hooks'
import { handleServerAPIError } from 'app/services/utils'

const AppsCardsGrid = () => {
    const { appsGrid } = useSelector((state: RootState) => state.appSlice)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useLayoutEffect(() => {
        dispatch(setIsLoading(true))
        getAppsGrid()
            .then(res => {
                dispatch(setAppsGrid(res.data.value))
            })
            .catch(e => handleServerAPIError(e, dispatch, navigate))
            .finally(() => dispatch(setIsLoading(false)))
    }, [])

    const onDetailsClick = useCallback(
        (appId: string) => {
            navigate(generatePath(APP_ROUTES.APP_DETAILS, { id: appId }))
        },
        [navigate],
    )

    const onDownloadClick = useCallback((appId: string, apkId: string) => {
        window.open(makeDownloadApkLink(appId, apkId), '_blank')
    }, [])

    return (
        <Container className="no-gutters">
            <Row className="match-height">
                {appsGrid.map((app, i) => (
                    <AppCard
                        key={i}
                        app={app}
                        onDetailsClick={onDetailsClick}
                        onDownloadClick={onDownloadClick}
                    />
                ))}
            </Row>
        </Container>
    )
}

export default AppsCardsGrid
